import {match, Pattern} from 'ts-pattern';

import {isNotNil} from 'ramda';

type WriteErrorWithStatus = {
  status: unknown;
};

const hasStatus = (error: unknown): error is WriteErrorWithStatus =>
  isNotNil(error) && typeof error === 'object' && 'status' in error;

export const isRetryableWriteError = (error: unknown) =>
  match(error)
    .when(hasStatus, ({status}) =>
      match(status)
        .when(
          (value): value is number => typeof value === 'number',
          // AWS WAF returns 403 when it blocks a burst.
          (httpStatus) =>
            httpStatus === 403 || httpStatus === 408 || httpStatus === 429 || httpStatus >= 500
        )
        .with(
          Pattern.union('FETCH_ERROR', 'PARSING_ERROR', 'TIMEOUT_ERROR', 'CUSTOM_ERROR'),
          () => true
        )
        .otherwise(() => false)
    )
    .otherwise(() => true);
